import { useDataProvider } from 'react-admin';
import { useQuery } from 'react-query';
/**
 * Call the dataProvider.getLock() method and return the resolved lock if it exists,
 * as well as the loading state.
 *
 * @param {string} resource
 * @param {GetLockParams} params The getLock parameters { id, meta }
 * @param {Object} options React Query Options object
 *
 * @returns The current lock state. Destructure as { data, error, isLoading, isFetching }.
 *
 * @example Simple Usage
 *
 * ```tsx
 * const { data } = useGetLock('posts', { id: 123 });
 * ```
 *
 * @example Getting resource and recordId from context
 *
 * ```tsx
 * const resource = useResourceContext();
 * const id = useGetRecordId();
 * const { data: lock } = useGetLock(resource, { id });
 * ```
 *
 * @example Custom toolbar
 *
 * ```tsx
 * const CustomToolbar = () => {
 *     const resource = useResourceContext();
 *     const id = useGetRecordId();
 *     const { isLoading: loading, data: lock } = useGetLock(resource, { id });
 *
 *     const isMarioLocker = lock?.identity === 'mario';
 *
 *     return (
 *         <Toolbar>
 *             <SaveButton disabled={loading || !isMarioLocker} />
 *             {!lock?.identity ? null : isMarioLocker ? (
 *                 <LockMessage>{`You're locking this record`}</LockMessage>
 *             ) : (
 *                 <LockMessage>
 *                     {`This record is locked by another inhabitant of the mushroom kingdom: ${lock?.identity}.`}
 *                 </LockMessage>
 *             )}
 *         </Toolbar>
 *     );
 * };
 * ```
 *
 */
export function useGetLock(resource, params, options) {
    if (options === void 0) { options = {}; }
    var dataProvider = useDataProvider();
    return useQuery([resource, 'getLock', params], function () { return dataProvider.getLock(resource, params).then(function (_a) {
        var data = _a.data;
        return data;
    }); }, options);
}
